var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'bounce-animation': _vm.playAnimation,
    'bounce-fixed-bottom': true,
    'bounce-bonus-text': true,
  },attrs:{"id":"animation-container"}},[_vm._v(" "+_vm._s(_vm.czxpAward > 0 ? "+" : "")+_vm._s(_vm.czxpAward)+" "),_c('img',{staticClass:"bounce-coin-size",attrs:{"src":require("@/assets/zoomTokenCoin.svg"),"alt":"zoom coin"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }